import { Component, OnInit, ChangeDetectionStrategy, ChangeDetectorRef, OnDestroy } from '@angular/core';
import { ViewTreeNode } from 'src/app/engine/models/view.tree-node';
import { BdGraphService } from 'src/lib/graph/graph.service';
import { Select, Store } from '@ngxs/store';
import { EngineState } from 'src/app/engine/state/engine.state';
import { Observable, Subject } from 'rxjs';
import { BdGraph } from 'src/lib/graph/graph.model';
import { takeUntil, filter } from 'rxjs/operators';
import { EngineNodesState } from 'src/app/engine/state/nodes/engine.nodes.state';

@Component({
  selector: 'app-engine-breadcrumb',
  templateUrl: './engine-breadcrumb.component.html',
  styleUrls: ['./engine-breadcrumb.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class EngineBreadcrumbComponent implements OnInit, OnDestroy {
  @Select(EngineNodesState.getHoveredNode)
  hoveredNode$: Observable<ViewTreeNode>;
  
  @Select(EngineNodesState.getCheckedNodes)
  checkedNodes$: Observable<ViewTreeNode[]>;

  node: ViewTreeNode;
  nodeAncestors: string;


  private ngUnsubscribe = new Subject();

  constructor(
    private graphService: BdGraphService,
    private store: Store,
    private changeDetection: ChangeDetectorRef
  ) { }

  ngOnInit() {
    this.hoveredNode$
      .pipe(
        filter(node => node != null),
        takeUntil(this.ngUnsubscribe)
      )
      .subscribe((node) => {
        this.nodeAncestors = this.getNodeAncestors(node)
          .map(ancestor => ancestor.label)
          .slice(0, -1)
          .join(' > ');

        if (this.nodeAncestors.length > 160) {
          this.nodeAncestors = `...${this.nodeAncestors.slice(-160)}`;
        }

        this.changeDetection.markForCheck();
      });
  }

  ngOnDestroy() {
    this.changeDetection.detach();

    this.ngUnsubscribe.next();
    this.ngUnsubscribe.complete();
  }

  getNodeAncestors(node: ViewTreeNode) {
    const viewGraph: BdGraph<ViewTreeNode> = this.store.selectSnapshot(EngineState.getViewGraph);
    
    return this.graphService
      .getAncestors(viewGraph, node.id, true)
      .map((id) => {
        return viewGraph.nodes[id];
      })
      .reverse();
  }
}
